//M10-12866
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface OrdPoState {
    OrderPoFilters: {
        company: any[] | undefined;
        status: any[] | undefined;
        stockist: any[] | undefined;
        counter: any[] | undefined;
    };
    OrdersPoFiltersData: {
        company: any[] | undefined;
        status: any[] | undefined;
        stockist: any[] | undefined;
        counter: any[] | undefined;
    };
    isResetFilter: boolean;
    orderPoData: any[] | null | undefined | any[];
    productsData: any | null | undefined | any[];
    cartDataObj: any;
    selectedCounterData: any | null | undefined | any[];
}

const ordPoState = createSlice({
    name: "ordPo",
    initialState: {
        OrderPoFilters: {
            company: [],
            stockist: [],
            status: [],
            counter: [],
        },
        isResetFilter: false,
        OrdersPoFiltersData: {
            company: [],
            status: [],
            stockist: [],
            counter: [],
        },
        orderPoData: [],
        productsData: null,
        selectedCounterData: null,
        cartDataObj: {},
    } as OrdPoState,
    reducers: {
        setOrderPoFilters(state, action: PayloadAction<{ key: keyof typeof state.OrderPoFilters; value: any[] | undefined }>) {
            const { key, value } = action.payload;
            state.OrderPoFilters[key] = value;
        },
        setOrdersPoFiltersData(state, action: PayloadAction<{ key: keyof typeof state.OrdersPoFiltersData; value: any[] | undefined }>) {
            const { key, value } = action.payload;
            state.OrdersPoFiltersData[key] = value;
        },
        setIsResetFilter(state, action: PayloadAction<boolean>) {
            state.isResetFilter = action.payload;
        },
        setOrderPoData(state, action: PayloadAction<any | null | undefined>): void {
            state.orderPoData = action.payload;
        },
        setProductsData(state, action: PayloadAction<any[] | null | undefined>): void {
            state.productsData = action.payload;
        },
        setCartDataObj(state, action: PayloadAction<any | null | undefined>): void {
            const { key, value } = action.payload;
            state.cartDataObj[key] = value;
        },
        removeCartDataObj(state, action: PayloadAction<any | null | undefined>): void {
            const { key } = action.payload;
            delete state.cartDataObj[key];
        },
        clearCartDataObj(state): void {
            state.cartDataObj = {};
        },
        setSelectedCounterData(state, action: PayloadAction<any | null | undefined>): void {
            state.selectedCounterData = action.payload;
        },
    },
});

export const ordPoActions = ordPoState.actions;
export { ordPoState };
//M10-12866